// extracted by mini-css-extract-plugin
module.exports = {"innerBurgerElement":"constructor-ingredient_innerBurgerElement__1ipLP","dragIcon":"constructor-ingredient_dragIcon__3LKwn"};